//components
import { isEmpty, pick } from 'lodash';
import { useEffect, useState } from 'react';
import Dropdown from '../../../Dropdown';
import Slider from '../../../Slider';
import { useIdCatalogSearch } from '../../context';

//styles
import { ControlWrapper, LabelActionButton, LabelActionButtonContainer } from '../../styles';
import { SlidersList } from '../EquipmentAdvancedFilter/styles';
import { Container } from './styles';

const ModuleAdvancedFilter = () => {
  const {
    dropdownsOptions,
    searchFilter,
    updateSearchFilterField,
    addFilterOption,
    removeFilterOption,
    updateFilterOptionValue,
    removeAllFilterOptions,
  } = useIdCatalogSearch();
  const { familyId, filterOptions } = searchFilter;

  const { projects, families, characteristics } = dropdownsOptions;
  const [shouldInvalidateCharacteristicsDropdow, setShouldInvalidateCharacteristicsDropdow] = useState(false);
  const [areFilterOptionsCollapsed, setAreFilterOptionsCollapsed] = useState(false);

  const shouldRenderCharacteristicsDropdown = !shouldInvalidateCharacteristicsDropdow;
  const shouldDisableCharacteristicsDropdown = !Boolean(familyId) || !shouldRenderCharacteristicsDropdown;

  const toggleCollapsedOptions = () => setAreFilterOptionsCollapsed((current) => !current);

  useEffect(() => {
    setShouldInvalidateCharacteristicsDropdow(true);
    window.requestAnimationFrame(() => setShouldInvalidateCharacteristicsDropdow(false));
  }, [familyId]);

  return (
    <div>
      <Container>
        <ControlWrapper>
          <Dropdown
            isLoading={projects.isLoading}
            options={projects.options}
            isOptional={false}
            value={searchFilter.projectId}
            placeholder='Select project'
            onChange={({ value }) => updateSearchFilterField('projectId', value)}
            isDisabled={false}
          />
        </ControlWrapper>
        <ControlWrapper>
          <Dropdown
            isLoading={families.isLoading}
            options={families.options}
            isOptional={false}
            value={searchFilter.familyId}
            placeholder='Select Family'
            onChange={({ value }) => updateSearchFilterField('familyId', value)}
            isDisabled={false}
          />
        </ControlWrapper>
        {shouldRenderCharacteristicsDropdown && (
          <ControlWrapper>
            <Dropdown
              isLoading={characteristics.isLoading}
              options={characteristics.options}
              isOptional={false}
              value={undefined}
              placeholder='Add filter option'
              onChange={({ value }) => addFilterOption(value)}
              isDisabled={shouldDisableCharacteristicsDropdown}
            />
          </ControlWrapper>
        )}
        {shouldRenderCharacteristicsDropdown && !isEmpty(filterOptions) && (
          <LabelActionButtonContainer>
            <LabelActionButton onClick={() => removeAllFilterOptions()}>Remove all filters</LabelActionButton>
          </LabelActionButtonContainer>
        )}
        {shouldRenderCharacteristicsDropdown && !isEmpty(filterOptions) && (
          <LabelActionButtonContainer>
            <LabelActionButton
              onClick={() => toggleCollapsedOptions()}
              color={'#4175c2'}
              style={{ fontWeight: 'bold' }}>
              {areFilterOptionsCollapsed ? 'Show filters' : 'Hide filters'} (
              <label className='counter'>{filterOptions.length}</label>)
            </LabelActionButton>
          </LabelActionButtonContainer>
        )}
        {!areFilterOptionsCollapsed && (
          <SlidersList>
            {filterOptions.map((option) => (
              <ControlWrapper key={option.id}>
                <Slider
                  range={pick(option, ['min', 'max'])}
                  defaultValue={option.value}
                  infoLabel={option.name}
                  unit={option.unit}
                  onChange={(value) => updateFilterOptionValue(option.id, value)}
                  onClose={() => removeFilterOption(option.id)}
                />
              </ControlWrapper>
            ))}
          </SlidersList>
        )}
      </Container>
    </div>
  );
};

export default ModuleAdvancedFilter;
